<template>
	<v-chip
		:close="close"
		:color="color"
		:disabled="disabled"
		:outlined="outlined"
		:small="small"
		:x-small="xSmall"
		@click="on_click"
		@click:close="handle_close"
		v-bind="$attrs"
		v-on="unhandled_events"
	>
		<slot></slot>
	</v-chip>
</template>

<script>
export default {
	props: {
		close: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: undefined
		},
		disabled: {
			type: Boolean,
			default: false
		},
		outlined: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		xSmall: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		on_click(event) {
			this.$emit('click', event);
		},
		handle_close(event) {
			this.$emit('click:close', event);
		}
	},
	computed: {
		unhandled_events() {
			const { click, 'click:close': clickClose, ...rest } = this.$listeners;
			return rest;
		}
	}
};
</script>
